import { ConfigRoutes } from "../../shared/models/general/utils.interface";

interface AccesosHerramientas {
    ALERTAS_CORREO: ConfigRoutes
    TSI_REPORTES: ConfigRoutes
    EXPORTAR_IMPORTAR: ConfigRoutes
    EXPORTAR_IMPORTAR_MAESTROS: ConfigRoutes
    EXPORTAR_IMPORTAR_TRANSACCIONES: ConfigRoutes
    EXPORTAR_IMPORTAR_MIGRACIONES: ConfigRoutes
    EXPORTAR_IMPORTAR_PLANILLAS: ConfigRoutes
    ACTUALIZACION_ANALYTICS: ConfigRoutes
    MIGRACION_API: ConfigRoutes
    LOTES_IMPORTACION: ConfigRoutes
    LOTES_IMPORTACION_MAESTROS: ConfigRoutes
    INTEGRACION: ConfigRoutes
    INTEGRACION_FALABELLA: ConfigRoutes
    FALABELLA_IMPORTAR_OP: ConfigRoutes
    FALABELLA_GENERAR_PDF: ConfigRoutes
    INTEGRACION_SHOPIFY: ConfigRoutes
    SHOPIFY_TIENDAS: ConfigRoutes
    SHOPIFY_EVENTOS: ConfigRoutes
    SHOPIFY_MAPEOS: ConfigRoutes
}

interface ModuloHerramientas {
    ID: number
    ACCESOS: AccesosHerramientas
}

const pathModulo = '/tools/'

export const MODULO_HERRAMIENTAS: ModuloHerramientas = {
    ID: 23,
    ACCESOS: {
        ALERTAS_CORREO: {
            TITLE: 'Alertas por correo',
            ACCESS: 1,
            PATH_MODULE: pathModulo,
            DESCRI: 'Alertas por correo',
            ROUTE: 'correo-alert'
        },
        TSI_REPORTES: {
            TITLE: 'TSI Reportes',
            ACCESS: 2,
            PATH_MODULE: pathModulo,
            DESCRI: 'TSI Reportes',
            ROUTE: 'tsi-reports'
        },
        EXPORTAR_IMPORTAR: {
            TITLE: 'Exportar/Importar',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            ROUTE: 'export-import'
        },
        EXPORTAR_IMPORTAR_MAESTROS: {
            TITLE: 'Maestros',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Exportar/Importar - Maestros',
            ROUTE: 'export-import/maestros'
        },
        EXPORTAR_IMPORTAR_TRANSACCIONES: {
            TITLE: 'Transacciones',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Exportar/Importar - Transacciones',
            ROUTE: 'export-import/transacciones'
        },
        EXPORTAR_IMPORTAR_MIGRACIONES: {
            TITLE: 'Migraciones',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Exportar/Importar - Migraciones',
            ROUTE: 'export-import/migraciones'
        },
        EXPORTAR_IMPORTAR_PLANILLAS: {
            TITLE: 'Planillas',
            ACCESS: 3,
            PATH_MODULE: pathModulo,
            DESCRI: 'Exportar/Importar - Planillas',
            ROUTE: 'export-import/planillas'
        },
        ACTUALIZACION_ANALYTICS: {
            TITLE: 'Actualización Analytic',
            ACCESS: 4,
            PATH_MODULE: pathModulo,
            DESCRI: 'Actualización Analytic',
            ROUTE: 'update-analytics'
        },
        MIGRACION_API: {
            TITLE: 'Migración API',
            ACCESS: 5,
            PATH_MODULE: pathModulo,
            DESCRI: 'Migración API',
            ROUTE: 'migration-api'
        },
        LOTES_IMPORTACION: {
            TITLE: 'Lotes de importación',
            ACCESS: 6,
            PATH_MODULE: pathModulo,
            DESCRI: 'Lotes de importación',
            ROUTE: 'consult-import-lots'
        },
        LOTES_IMPORTACION_MAESTROS: {
            TITLE: 'Importación de maestros',
            ACCESS: 8,
            PATH_MODULE: pathModulo,
            DESCRI: 'Lotes de importación de maestros',
            ROUTE: 'consult-import-lots-masters'
        },
        INTEGRACION: {
            TITLE: 'Integración',
            ACCESS: 7
        },
        INTEGRACION_FALABELLA: {
            TITLE: 'Falabella',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            ROUTE: 'falabella'
        },
        FALABELLA_IMPORTAR_OP: {
            TITLE: 'Importación de OP',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            DESCRI: 'Integración Falabella - Importación de OP',
            ROUTE: 'falabella/import-order'
        },
        FALABELLA_GENERAR_PDF: {
            TITLE: 'Generar PDF',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            DESCRI: 'Integración Falabella - Generar PDF',
            ROUTE: 'falabella/generate-pdf'
        },
        INTEGRACION_SHOPIFY: {
            TITLE: 'Shopify',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            ROUTE: 'shopify'
        },
        SHOPIFY_TIENDAS: {
            TITLE: 'Tiendas',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            DESCRI: 'Integración Shopify - Configuración de tiendas',
            ROUTE: 'shopify/stores'
        },
        SHOPIFY_EVENTOS: {
            TITLE: 'Eventos',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            DESCRI: 'Integración Shopify - Eventos',
            ROUTE: 'shopify/events'
        },
        SHOPIFY_MAPEOS: {
            TITLE: 'Mapeos',
            ACCESS: 7001,
            PATH_MODULE: pathModulo,
            DESCRI: 'Integración Shopify - Mapeos',
            ROUTE: 'shopify/mappings'
        }
    }
}

export const MODULO_HERRAMIENTAS_BUSQUEDA = Object.entries(MODULO_HERRAMIENTAS.ACCESOS).filter(item => item[1].DESCRI != null)
